import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import logo from "../../assets/iconnew.png";

import "./Navigation.css";
import TopStrip from "../TopStrip/TopStrip"

export default function Navigation() {
  // Add state for each dropdown
  const [aboutShow, setAboutShow] = useState(false);
  const [businessShow, setBusinessShow] = useState(false);
  const [investorsShow, setInvestorsShow] = useState(false);
  
  // Handler functions for mouse events
  const handleAboutMouseEnter = () => setAboutShow(true);
  const handleAboutMouseLeave = () => setAboutShow(false);
  
  const handleBusinessMouseEnter = () => setBusinessShow(true);
  const handleBusinessMouseLeave = () => setBusinessShow(false);
  
  const handleInvestorsMouseEnter = () => setInvestorsShow(true);
  const handleInvestorsMouseLeave = () => setInvestorsShow(false);

  return (
    <>
      <TopStrip />
      <Navbar expand="lg" className="bg-body-tertiary">
        <Container>
          <Navbar.Brand href="/">
            <img
              src={logo}
              className="d-inline-block align-top"
              alt="React Bootstrap logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="w-100 justify-content-center gap-3">
              <Nav.Link href="/">Home</Nav.Link>
              <NavDropdown 
                title="About" 
                id="about-dropdown" 
                className="custom-dropdown"
                show={aboutShow}
                onMouseEnter={handleAboutMouseEnter}
                onMouseLeave={handleAboutMouseLeave}
              >
                <NavDropdown.Item href="/promoters">PROMOTERS</NavDropdown.Item>
                <NavDropdown.Item href="/board-of-directors">BOARD OF DIRECTORS</NavDropdown.Item>
                <NavDropdown.Item href="/key-managerial-personnel">LEADERSHIP TEAM</NavDropdown.Item>
                <NavDropdown.Item href="/awards">AWARDS & RECOGNITION</NavDropdown.Item>
                <NavDropdown.Item href="/certifications">CERTIFICATIONS</NavDropdown.Item>
                <NavDropdown.Item href="/news">NEWS & EVENTS</NavDropdown.Item>
              </NavDropdown>
              <NavDropdown 
                title="Business Relations" 
                id="business-dropdown" 
                className="custom-dropdown"
                show={businessShow}
                onMouseEnter={handleBusinessMouseEnter}
                onMouseLeave={handleBusinessMouseLeave}
              >
                <NavDropdown.Item href="/electrical-works">Electrical Engineering Works</NavDropdown.Item>
                <NavDropdown.Item href="/civil-works">Civil Engineering Works</NavDropdown.Item>
              </NavDropdown>
              <Nav.Link href="/careers">Careers</Nav.Link>
              <Nav.Link href="/gallery">Gallery</Nav.Link>
              <NavDropdown 
                title="Investors" 
                id="investors-dropdown" 
                className="custom-dropdown"
                show={investorsShow}
                onMouseEnter={handleInvestorsMouseEnter}
                onMouseLeave={handleInvestorsMouseLeave}
              >
                <NavDropdown.Item href="/disclosure-reg-46">DISCLOSURE UNDER REG 46 OF SEBI LODR</NavDropdown.Item>
                <NavDropdown.Item href="/disclosure-reg-62">DISCLOSURE UNDER REG 62 OF SEBI LODR</NavDropdown.Item>
                <NavDropdown.Item href="/shareholders-meeting">SHAREHOLDERS MEETING RESULTS</NavDropdown.Item>
                <NavDropdown.Item href="/policies">POLICIES & CODES</NavDropdown.Item>
                <NavDropdown.Item href="/unclaimed-dividends">UNCLAIMED DIVIDENDS</NavDropdown.Item>
                <NavDropdown.Item href="/smart-odr">SMART ODR</NavDropdown.Item>
              </NavDropdown>
              <Nav.Link href="/contact">Contact Us</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}